import { Checkbox, Grid } from "@mui/material";
import PropTypes from "prop-types";
import SoftBox from "components/SoftBox";
import SoftInput from "components/SoftInput";
import SoftTypography from "components/SoftTypography";
import Campo from "../Campo";
import { MENSAJE_BLOQUEO_MAX, MENSAJE_BLOQUEO_PREDETERMINADO } from "../../utils";

const Opcion = ({ checked, disabled, onChange, titulo, detalle }) => (
  <SoftBox component="label" display="flex" alignItems="flex-start" gap={1} p={1.5} borderRadius="lg"
    sx={{
      cursor: disabled ? "default" : "pointer",
      border: ({ borders: { borderWidth, borderColor } }) => `${borderWidth[1]} solid ${borderColor}`,
    }}>
    <Checkbox checked={checked} disabled={disabled} onChange={(_, value) => onChange(value)} sx={{ mt: -0.5 }} />
    <SoftBox>
      <SoftTypography variant="button" fontWeight="bold" display="block">{titulo}</SoftTypography>
      <SoftTypography variant="caption" color="secondary">{detalle}</SoftTypography>
    </SoftBox>
  </SoftBox>
);

Opcion.propTypes = {
  checked: PropTypes.bool.isRequired, disabled: PropTypes.bool, onChange: PropTypes.func.isRequired,
  titulo: PropTypes.string.isRequired, detalle: PropTypes.string.isRequired,
};

export default function PasoAutogestion({ form, setField, errores, soloLectura }) {
  const total = form.bloqueaAppCompleta;
  const hayBloqueo = total || form.bloqueaMenu || form.bloqueaCafeteria;
  const predeterminado = total ? MENSAJE_BLOQUEO_PREDETERMINADO.app
    : form.bloqueaMenu ? MENSAJE_BLOQUEO_PREDETERMINADO.menu : MENSAJE_BLOQUEO_PREDETERMINADO.cafeteria;

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <SoftTypography variant="caption" color="secondary">
          Aplica a la app Sistema Comedor y al tótem mientras dura el evento. El punto de venta y el panel administrativo no se bloquean.
        </SoftTypography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Opcion checked={total || form.bloqueaMenu} disabled={total || soloLectura} onChange={(value) => setField("bloqueaMenu", value)}
          titulo="Bloquear pedidos de menú" detalle="La cafetería sigue disponible." />
      </Grid>
      <Grid item xs={12} md={4}>
        <Opcion checked={total || form.bloqueaCafeteria} disabled={total || soloLectura} onChange={(value) => setField("bloqueaCafeteria", value)}
          titulo="Bloquear pedidos de cafetería" detalle="El menú sigue disponible." />
      </Grid>
      <Grid item xs={12} md={4}>
        <Opcion checked={total} disabled={soloLectura} onChange={(value) => setField("bloqueaAppCompleta", value)}
          titulo="Suspender toda la app" detalle="Muestra solo un aviso de suspensión." />
      </Grid>
      {hayBloqueo && (
        <Grid item xs={12}>
          <Campo id="evento-mensaje" label="Mensaje para los usuarios" error={errores.mensajeBloqueo}
            ayuda={`Si lo deja vacío, se muestra el texto de ejemplo. ${form.mensajeBloqueo.length}/${MENSAJE_BLOQUEO_MAX} caracteres.`}>
            <SoftInput id="evento-mensaje" multiline rows={2} value={form.mensajeBloqueo} error={Boolean(errores.mensajeBloqueo)} disabled={soloLectura}
              onChange={(e) => setField("mensajeBloqueo", e.target.value)} placeholder={predeterminado}
              inputProps={{ maxLength: MENSAJE_BLOQUEO_MAX, disabled: soloLectura }} />
          </Campo>
        </Grid>
      )}
    </Grid>
  );
}

PasoAutogestion.propTypes = {
  form: PropTypes.object.isRequired,
  setField: PropTypes.func.isRequired,
  errores: PropTypes.object,
  soloLectura: PropTypes.bool,
};

PasoAutogestion.defaultProps = { errores: {}, soloLectura: false };
